import {EventEmitter} from "events";

class ServicesStore extends EventEmitter {
	constructor() {
		super();
		this.services = [];
	}
	setServices (data) {
		this.services = data.reduce((val,act)=>{
			let busWithModel = act.buses.map((bus) =>{
				return {
					...bus,
					model: act.id
				}
			});
			return val.concat(busWithModel);
		},[]).reduce((val,act)=>{
			let serviceWithModel = act.services.map((service) =>{
				return {
					...service,
					model: act.model
				}
			});
			return val.concat(serviceWithModel);
		},[]);
	}
	getServiceById (id) {
		return this.services.find((service)=>{
			return service.id == id
		})
	}
	getContractor () {
		return this.contractor;
	}
	setContractor (data) {
		this.contractor = data;
		this.emit("new-contractor")
	}
}

const servicesStore = window.store = new ServicesStore();

export default servicesStore;


/** WEBPACK FOOTER **
 ** ./src/stores/ServicesStore.js
 **/